<template>
  <div id="lpages" class="cc_ssc-block">
   <table border="0" cellpadding="0" class="t1" cellspacing="0" width="700">
		<tbody>
		<tr>
			<td colspan="3">
				<div style="width:100%;height:5px;background-color:#b5b6b6;"></div>
			</td>
		</tr>
		<tr>
			<td class="ctColor" colspan="4" valign="bottom">
				<table border="0" cellpadding="0" cellspacing="0" width="700" class="ftable" rules="all">
					<tbody>
          <g-switch-list6
          :horizontal-type="1"
          :chip="chip"
          :list="top1[0].list"></g-switch-list6>
					<tr class="Conter_list">
              <g-switch-list6
              :horizontal-type="2"
              :chip="chip"
              :list="top1[1].list"></g-switch-list6>
						<td class="t_Edit_caption_3 ftd" style="width:60%;background-color:#b5b6b6;" colspan="3" rowspan="3">
							<table style="margin-top:1px;" class="ftable">
								<tbody>
                <tr style="height:73px;">
									<td style="width:23%;">
										<img src="../../../assets/left_UP.png?1" style="vertical-align:bottom;">
									</td>
									<td id="td2" class="fan t_Edit_caption_3" style="background-color:#FFDF2D;width:54%;" colspan="2">
										<g-switch-list6
          :horizontal-type="5"
          :chip="chip"
          :list="top1[14].list"></g-switch-list6>
									</td>
									<td style="width:23%;">
										<img src="../../../assets/right_up.png?1" usemap="#right_up" style="vertical-align:bottom;">
									</td>
								</tr>
								<tr>
									<td id="td3" class="fan t_Edit_caption_3" style="background-color:#FE3315;height:75px;">
										<g-switch-list6
          :horizontal-type="5"
          :chip="chip"
          :list="top1[15].list"></g-switch-list6>
									</td>
									<td class="dan t_Edit_caption_3" style="height:75px;">
										<g-switch-list6
          :horizontal-type="5"
          :chip="chip"
          :list="top1[16].list"></g-switch-list6>
									</td>
									<td class="dan t_Edit_caption_3" style="height:75px;">
										<g-switch-list6
          :horizontal-type="5"
          :chip="chip"
          :list="top1[17].list"></g-switch-list6>
									</td>
									<td id="td1" class="fan t_Edit_caption_3" style="background-color:#6EFF30;height:75px;">
										<g-switch-list6
          :horizontal-type="5"
          :chip="chip"
          :list="top1[13].list"></g-switch-list6>
									</td>
								</tr>
								<tr style="height:73px;">
									<td style="width:23%;">
										<img src="../../../assets/left_Down.png?1" usemap="#left_Down" style="vertical-align:bottom;width:100%;">
									</td>
									<td id="td4" class="fan t_Edit_caption_3" colspan="2" style="background-color:#DDDDDD;">
										<g-switch-list6
          :horizontal-type="5"
          :chip="chip"
          :list="top1[12].list"></g-switch-list6>
									</td>
									<td style="width:23%;">
										<img src="../../../assets/right_Down.png?1" usemap="#right_Down" style="vertical-align:bottom;width:100%;">
									</td>
								</tr>
							</tbody></table>
						</td>
						<g-switch-list6
              :horizontal-type="2"
              :chip="chip"
              :list="top1[3].list"></g-switch-list6>
					</tr>
          <g-switch-list6
            :horizontal-type="3"
            :chip="chip"
            :list="top1[2].list"></g-switch-list6>
					<g-switch-list6
            :horizontal-type="3"
            :chip="chip"
            :list="top1[4].list"></g-switch-list6>
					<g-switch-list6
          :horizontal-type="1"
          :chip="chip"
          :list="top1[5].list"></g-switch-list6>
				</tbody></table>
				
				<div style="width:100%;height:5px;background-color:#b5b6b6;"></div>
				<table border="0" cellpadding="0" cellspacing="0" width="700" class="Man_Conter ax">
					<tbody>
          <g-switch-list6
          :horizontal-type="4"
          :chip="chip"
          :list="top1[6].list"></g-switch-list6>
          <!--<g-switch-list7
          :columns="4"
          :horizontal-type="4"
          :chip="chip"
          :title="top1[7].title"
          :list="top1[7].list"></g-switch-list7>
          <g-switch-list7
          :columns="4"
          :horizontal-type="4"
          :chip="chip"
          :title="top1[8].title"
          :list="top1[8].list"></g-switch-list7>
          <g-switch-list7
          :columns="4"
          :horizontal-type="4"
          :chip="chip"
          :title="top1[9].title"
          :list="top1[9].list"></g-switch-list7>
          <g-switch-list7
          :columns="4"
          :horizontal-type="4"
          :chip="chip"
          :title="top1[10].title"
          :list="top1[10].list"></g-switch-list7>
          <g-switch-list7
          :columns="4"
          :horizontal-type="4"
          :chip="chip"
          :title="top1[11].title"
          :list="top1[11].list"></g-switch-list7>-->
				</tbody></table>
			</td>
		</tr>
	</tbody></table>
  </div>
</template>

<script>
  import GSwitchList6 from '../../c_game-switch/switch-list/g_switch-6';
  import GSwitchList7 from '../../c_game-switch/switch-list/g_switch-7';
  export default {
    name: "fantan-1",
    props: {
      chip: String,
      data: {
        type: Object,
        default() {
          return {
            vertical: [
            ],
            horizontal: [
            ]
          }
        }
      }
    },
    components: {
      GSwitchList6,
      GSwitchList7,
    },
    computed: {
      componentName () {
        return 1
      },
      top1 () {
        return this.data.horizontal || {};
      },
      top_else () {
        return this.data.horizontal.slice(1) || [];
      }
    },
    methods: {
      onSelectItem(item) {
        if (item.status >= 2) return;
        this.selected = !this.selected;
        if (
          this.name === "g_input_selected_item" ||
          this.name === "g_input_selected_item_type_2"
        ) {
          this.value = this.selected ? this.chip : "";
        }
        this.$refs.input && this.$refs.input.focus();
        if(this.selected)
        {
            this.value=this.$store.state.inputnum;	
        }
      }
    },
    data () {
      return {
        selected: false,
        value: "",
        tabs: [
          {
            title: ''
          }
        ]
      }
    }
  }
</script>

<style scoped lang="stylus">
@media screen and (max-width: 900px) {
  .t1{width:520px !important;}
}
  .cc_ssc-block
    overflow hidden
    position relative
    margin-top 5px
    .cs_horizontal{
      margin-top 7px
    }
    .cs-wrap
      width calc(20% - 5.6px)
      float left
      margin-top 7px
    .cs-wrap + .cs-wrap
      margin-left 7px
* {
    margin: 0;
    padding: 0;
    font-size: 12px;
    color: #441E0B;
    font-family: Verdana, "å®‹ä½“", Arial,Sans;
}
html, body, div, span, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, abbr, address, cite, code, del, dfn, em, img, ins, kbd, q, samp, small, strong, sub, sup, var, b, i, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, figcaption, figure, footer, header, hgroup, menu, nav, section, summary, time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    font-size: 100%;
    background: transparent;
}
.ftable {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
    color: white;
}
tr {
    font-size: 14px;
}
.Conter_list {
    height: 28px!important;
}
.t_Edit_caption_3 {
    width: 52px;
    height: 29px;
    line-height: 26px;
    text-align: center;
    background: #fdf8f2;
    vertical-align: middle;
}
.ftd {
    border: 2px #b5b6b6 solid;
}
.jal {
    background-color: #333301;
}
.lan {
    background-color: #7D7D00;
}
.playn {
    color: red;
    font-size: 12pt;
}
span[id^=r] {
    color: rgb(68, 30, 11);
    text-shadow: -1px -1px 1px #ffffff, 1px 1px 1px #ffffff, -1px 1px 1px #ffffff, 1px -1px 1px #ffffff;
}
.dan {
    background-color: #979700;
    border: 1px #7D7D00 solid;
}
.ftable span {
    color: white;
}
span[id^=r] {
    color: rgb(68, 30, 11);
    text-shadow: -1px -1px 1px #ffffff, 1px 1px 1px #ffffff, -1px 1px 1px #ffffff, 1px -1px 1px #ffffff;
}
.fan span {
    color: rgb(68, 30, 11);
}
span[id*=_rat], span[id*=r_], span[id*=rt_], td[id*=r_], td[id*=rt_] {
    font-weight: bold;
}
.Man_Conter {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
}
.ax {
    margin-top: -1px;
}
.Man_Conter td, th {
    border: 1px #E9BA84 solid;
    line-height: 30px;
}
.odds_a {
    color: red;
    font-weight: bold;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
    cursor: pointer;
}
td[id*=_num], span[id*=n_], span[id*=nt_], td[id*=n_], td[id*=nt_], div[id*=n_], div[id*=nt_], span[class=sGameStatusItem] {
    font-weight: bold;
}
.inp1{
  border: 1px solid #bfbfbf;
  display: inline-block;
  border-radius: 2px;
}
/*
.theme-1 .inp1{
    background: rgba(255,169,51,0.102);
}
.theme-2 .inp1{
    background: #e8f9eb;
}
.theme-3 .inp1 {
    background: rgba(165,113,209,0.071);
}*/
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/fantan/fantan-1.vue